import { Container, Stack, Typography } from '@mui/material'
import React, { FC } from 'react'
import ButtonUI from '../../../components/button/buttons'


interface DeleteCard {
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  onConfirm: () => Promise<void>;
  loading: boolean;
}

export const ModalDeleteCard:FC<DeleteCard> = (props) => {
    return (
    <Container maxWidth="xs">
      <Stack direction="column" justifyContent="center" margin="5px">
        <Typography
          fontSize="26px"
          color="#1A455F"
          fontWeight="bold"
          align="center"
        >
          ¿Desea desbloquear este número de tarjeta?
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="center" margin="5px">
        <Typography fontSize="22px" fontWeight="bold" color="#00350392">
        </Typography>
      {/* <Typography fontSize="22px">{": " + props?.data}</Typography> */}
      </Stack>

      <Stack
        direction="row"
        justifyContent="space-evenly"
        alignItems="center"
        padding="5px"
      >
        <ButtonUI
          disabled={props.loading}
          id="button-back"
          title="Regresar"
           onClick={() => props.setOpenModal(false)}
        />
        <ButtonUI
          loading={props.loading}
          id="button-create-withdrawl"
          title="Desbloquear"
          color="primary"
          onClick={() => props.onConfirm()}
        />
      </Stack>
    </Container>
    )
}
